import Record from "Types/Record";
import Billing from "Types/billing";
import { Map } from "immutable";

export const TRIAL = "trial";
export const FREE = "free";
export const PRO = "pro";
export const PAY_AS_YOU_GO = "pay_as_you_go";
export const ENTERPRISE = "enterprise";

export const PLAN_TYPES = { TRIAL, FREE, PRO, PAY_AS_YOU_GO, ENTERPRISE };
export const PLAN_TEXT = {
  [FREE]: "Free",
  [TRIAL]: "Trial",
  [PAY_AS_YOU_GO]: "Serverless",
  [ENTERPRISE]: "Enterprise",
  [PRO]: "Pro",
};

export default Record(
  {
    id: undefined,
    old: undefined,
    trialEnded: undefined,
    hasActivePlan: undefined,
    current: Map(),
    remaining: Map(),
    billing: Billing(),
    count: Map(),
  },
  {
    idKey: "id",
    methods: {
      validate() {
        return true;
      },
      isPro() {
        return this.current.type === ENTERPRISE;
      },
      toData() {
        const js = this.toJS();
        delete js.nextBillingDate;
        return js;
      },
    },
    fromJS: ({ billing, ...rest }) => ({
      ...rest,
      billing: Billing(billing),
    }),
  },
);
